import { useAuth } from "@/contexts/AuthContext"
import { Sidebar } from "@/components/organisms/Sidebar"
import { SidebarNavItem } from "@/components/organisms/Sidebar/Sidebar.types"
import logoFull from "@/assets/horizontal-logo.png"
import logoSmall from "@/assets/symbol.png"

const menuItems: SidebarNavItem[] = [
  { label: "Dashboard", to: "/dashboard", icon: "chart-pie-alt" },
  { label: "Mentorias", to: "/mentorings", icon: "diploma" },
  { label: "Empresas", to: "/companies", icon: "building" },
  { label: "Relatórios", to: "/reports", icon: "newspaper" },
  { label: "Configurações", to: "/settings", icon: "settings", disabled: true },
]

export function AppSidebar() {
  const { user } = useAuth()

  const profile = {
    name: user?.nome || "Usuário",
    role: user?.departamento,
    avatarSrc: user?.pes_foto_url,
    avatarFallback: user?.nome,
  }

  return (
    <Sidebar
      logoFull={<img src={logoFull} />}
      logoSmall={<img src={logoSmall} />}
      navItems={menuItems}
      profile={profile}
      collapsable={true}
    />
  )
}
